import {ArrowForward} from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import Button from '../../../../form/buttons/Button/Button';

const ShowAllHistoryButton = ({onClick}) => {
  return (
    <Grid container justifyContent="center">
      <Button sx={{fontSize: 13}} variant="text" size="small" endIcon={<ArrowForward />} onClick={onClick}>
        Voir tout l'historique
      </Button>
    </Grid>
  );
};

ShowAllHistoryButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default ShowAllHistoryButton;
